import React from 'react'

export default function ContactUs() {
    return (
        <div>

<a href="https://dribbble.com/shots/6928696-Nakey">
              <img src="https://cdn.dribbble.com/users/694830/screenshots/6928696/nakey.gif"
            
            class='no-hover-image' alt="Nakey-smelling-flower"></img></a>
            <br></br>
            <br></br>
           
                <h2>Contact Us</h2>

            <ul class="no-dot-list">

                <li>This project is intented for open-source.All Resources from internet.</li>
                <li>If you find any resources that may infringes copyright.</li>
                <li>Please contract us and we would resolve it.</li>
                <li> Thank you. 🦩 </li>
                <li>✉︎  </li>
                <li><a href="mailto: learndefi@gmail.com">learndefi@gmail.com</a></li>
            </ul>
            
            
           
           
            
        </div>
    )
}
